import dataStore from "../../../data/data";

const parse = (body) => {
  const clone = body.clone(true);
  let extractedFace = null;

  clone.traverse((child) => {

    if (!child.isMesh) return;

    const material = child.material;

    const materials = Array.isArray(material)
      ? material
      : [material];

    const hasFaceMaterial = materials.some(
      (mat) => mat?.name?.toLowerCase() === 'face'
    );

    if (!hasFaceMaterial) return;

    if (child.geometry) {
      child.geometry = child.geometry.clone();
    }

    if (child.material) {
      if (Array.isArray(child.material)) {
        child.material = child.material.map(mat => mat.clone());
      } else {
        child.material = child.material.clone();
      }
    }

    extractedFace = child;
  });

  if (!extractedFace) {
    console.log('No face material found');
    return null;
  }

  return extractedFace;
};

const FacemeshInit = async (target) => {
  const data = dataStore.getState();
  const body = data.mediaprocessing[target]?.body;
  const facemesh = parse(body);
  return facemesh;
};

export default FacemeshInit;